KXL.module('GamesApp.Story', function(Story, KXL, Backbone, Marionette, $, _) {
	Story.Controller = {
		getStory: function (options) {
			return new Story.View(options);
		}
	};
});
